import { TokenService } from '../../../../../../services/authentication/token.service';
import { XsiteAxiosServiceFactory } from '../../../../../../services/axios/xsite-axios-service-factory';
import { XsiteIntegrationItem } from '../../../state/integrations-state';
import { IDeleteIntegrationDialogItemService } from './types';

export class DeleteIntegrationDialogXsiteService implements IDeleteIntegrationDialogItemService {
  constructor(private item: XsiteIntegrationItem) {}

  async deleteIntegration() {
    await XsiteAxiosServiceFactory.instance
      .createSkyMapXsiteConnectionServiceV1()
      .deleteSkyMapXsiteConnection({
        path: { skyMapXsiteConnectionId: this.item.integrationId! },
        query: { skyMapAuthenticationToken: new TokenService().get() },
      });
  }
}
